import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import * as React from "react";

import FinalResultsAccordian from "./FinalResultsAccordian";
import LiftingOrder from "./LiftingOrder";
import OtherFinalResults from "./OtherFinalResults";

type TabPanelProps = {
  children: JSX.Element | string;
  index: number;
  value: number;
};

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function getTabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    ["aria-controls"]: `simple-tabpanel-${index}`,
  };
}

export default function MCConsole() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Lift Order" {...getTabProps(0)} />
          <Tab label="Weight Class Final Results" {...getTabProps(1)} />
          <Tab label="Other Final Results" {...getTabProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <LiftingOrder />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <FinalResultsAccordian />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <OtherFinalResults />
      </TabPanel>
    </Box>
  );
}
